// extracted by mini-css-extract-plugin
export default {"hide":"index-module__hide___FhknH","navContainer":"index-module__navContainer___xSPbb","active":"index-module__active___cp0uA","dots":"index-module__dots___c0G9J"};